/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: queues-resource-factory.js
 *
 * Created by psnyder on 3/1/17.
 */
'use strict';

angular.module('prism-ui.components.data').factory('QueuesResourceFactory', function ($resource, EndPointService) {
	return $resource(EndPointService.queuesEndpoint + '/:id', {id: '@id', filter: '@filter', fetchOffset: '@fetchOffset', fetchLimit: '@fetchLimit'},
		{
			'getAllQueueLimiters': {
				method: 'GET',
				url: EndPointService.queuesEndpoint + '/:id/limiters',
				params: {id: '@id'},
				isArray: true
			},
			'createNewQueueLimiter': {
				method: 'POST',
				url: EndPointService.queuesEndpoint + '/:id/limiters',
				params: {id: '@id'},
				isArray: false
			},
			'getSingleQueueLimiter': {
				method: 'GET',
				url: EndPointService.queuesEndpoint + '/limiters/:id',
				params: {id: '@id'},
				isArray: false
			},
			'getQueueSteps': {
				method: 'GET',
				url: EndPointService.queuesEndpoint + '/:id/steps',
				params: {
					id: '@id',
					filter: '@filter',
					fetchOffset: '@fetchOffset',
					fetchLimit: '@fetchLimit'
				},
				isArray: true
			},
			'updateQueueStepPriority': {
				method: 'PUT',
				url: EndPointService.queuesEndpoint + '/steps/:id/priority',
				params: {id: '@id', priority: '@priority'},
				isArray: false
			},
			'updateLimiter': {
				method: 'PUT',
				url: EndPointService.queuesEndpoint + '/limiters/:id',
				params: {id: '@id'},
				isArray: false
			},
			'deleteQueueLimiter': {
				method: 'DELETE',
				url: EndPointService.queuesEndpoint + '/limiters/:id',
				params: {id: '@id'},
				isArray: false
			},
			'updateQueue': {
				method: 'PUT',
				url: EndPointService.queuesEndpoint + '/:id',
				params: {id: '@id'},
				isArray: false
			},
            'clearQueue': {
                method: 'DELETE',
                url: EndPointService.queuesEndpoint + '/:id',
                params: {id: '@id'},
                isArray: false
            }
		});
});
